var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoForMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.419,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_for_mobile_svg__a",
    y1: 0.953,
    x2: 1.083,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01cce4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0172f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1391"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 5",
    d: "M14.68 21.675c-6.888-2.241-13.691-3.34-14.458 0l-.2-1.432s-.791-7.552 8.374-4.461 11.691.66 11.855-.666c.079-.637.387 1.372-.079 3.382-.406 1.751-1.4 3.5-3.649 3.5a5.973 5.973 0 01-1.843-.323zm0-7.5c-6.888-2.241-13.691-3.34-14.458 0l-.2-1.432s-.796-7.55 8.369-4.459 11.691.66 11.855-.666c.079-.638.387 1.372-.079 3.382-.406 1.751-1.4 3.5-3.649 3.5a5.973 5.973 0 01-1.838-.323zm0-7.5C7.792 4.438.989 3.339.222 6.679l-.2-1.432S-.774-2.3 8.391.786s11.691.66 11.855-.666c.079-.638.387 1.372-.079 3.382-.406 1.751-1.4 3.5-3.648 3.5a5.974 5.974 0 01-1.839-.323z",
    fill: "url(#logo_for_mobile_svg__a)"
  }))));
}
export default SvgLogoForMobile;